import { isFirebaseConfigured } from "@/auth/firebase";
import { isApplyingRemotePlayerSave } from "@/cloud/player-cloud-apply-guard";
import { bumpPlayerSaveSectionTimestamp } from "@/cloud/player-cloud-timestamps";
import type { PlayerSaveSection } from "@/cloud/player-save-docs";

const PUSH_DEBOUNCE_MS = 2500;

let pushTimer: ReturnType<typeof setTimeout> | null = null;
let pendingPushUserId: string | null = null;

export function schedulePlayerCloudPush(userId: string, section: PlayerSaveSection): void {
  if (!isFirebaseConfigured()) return;
  if (isApplyingRemotePlayerSave()) return;
  bumpPlayerSaveSectionTimestamp(userId, section);
  pendingPushUserId = userId;
  if (pushTimer) clearTimeout(pushTimer);
  pushTimer = setTimeout(() => {
    const uid = pendingPushUserId;
    pushTimer = null;
    pendingPushUserId = null;
    if (!uid) return;
    void import("@/cloud/player-cloud-save").then((m) => m.flushPlayerCloudPush(uid));
  }, PUSH_DEBOUNCE_MS);
}

export async function flushPlayerCloudPushNow(userId: string): Promise<void> {
  if (!isFirebaseConfigured()) return;
  const m = await import("@/cloud/player-cloud-save");
  await m.flushPlayerCloudPush(userId);
}
